import { request } from '@umijs/max';
interface ImagePromptData {
  prompt: string;
  model_version: string;
  sample_count: string;
  negative_prompt: string;
  aspect_ratio: string;
  person_generation: string;
  output_options: string;
  style: string;
  secondary_style: string;
  light: string;
  light_coming_from: string;
  shot_from: string;
  perspective: string;
  image_colors: string;
  use_case: string;
}
interface ReferenceObjects {
  reference_type: string;
  image_url: string;
  description: string;
  ratio: string;
  width: number;
  height: number;
  ref_id: number;
  object_key: string;
  is_additional_image: boolean;
  product_name?: string;
}
// 图片生成
export async function ImageGenerate(
  data: {
    generate_image?: ImagePromptData;
    reference_objects?: ReferenceObjects[];
    request_id?: string;
  },
  options?: { [key: string]: any },
) {
  return request<API.ApiResponse>('/imgapi/v1/image/generate', {
    method: 'POST',
    data,
    ...(options || {}),
  });
}

// 根据图片生成Prompt
export async function getImagePrompt(
  data: {
    image_url: string;
    target: string;
  },
  options?: { [key: string]: any },
) {
  return request<API.ApiResponse>(`/imgapi/v1/image/prompt`, {
    method: 'POST',
    data,
    ...(options || {}),
  });
}
// 获取图片的描述
export async function creatImageDescription(
  data: {
    image_url: string;
    reference_type: string;
    product_name?: string;
  },
  options?: { [key: string]: any },
) {
  return request<API.ApiResponse>('/imgapi/v1/image/description', {
    method: 'POST',
    data,
    ...(options || {}),
  });
}

// 生成视频
interface InterpolImage {
  format: string;
  image_url: string;
}
interface VideoPromptData {
  prompt: string;
  modelVersion: string;
  isVideoWithAudio?: boolean;
  sampleCount: number;
  aspectRatio: string;
  durationSeconds: number;
  negativePrompt: string;
  personGeneration: string;
  cameraPreset?: string;
  style?: string;
  secondaryStyle?: string;
  motion?: string;
  framing?: string;
  angle?: string;
  ambiance?: string;
  effects?: string;
  interpolImageFirst?: InterpolImage;
  interpolImageLast?: InterpolImage;
}
export async function generateVideo(data: VideoPromptData, options?: { [key: string]: any }) {
  return request<API.ApiResponse>('/veoapi/v1/video/generate', {
    method: 'POST',
    data,
    ...(options || {}),
  });
}
// 获取视频的生成状态
export async function getVideoGenerationStatus(
  data: {
    operationName: string;
  },
  options?: { [key: string]: any },
) {
  return request<API.ApiResponse>('/veoapi/v1/video/generation_status', {
    method: 'POST',
    data,
    ...(options || {}),
  });
}

// 图片扩展编辑
export async function imageEditOutpaint(
  data: {
    model_version: string;
    prompt?: string;
    sample_count: number;
    input_image: string;
    input_mask_image: string;
    aspect_ratio: string;
    width: number; // 扩展后的宽度
    height: number; // 扩展后的高度
    edit_mode: string;
    mask_dilation: number;
    base_steps: number;
    output_options: string;
    person_generation: string;
    negative_prompt: string;
  },
  options?: { [key: string]: any },
) {
  return request<API.ApiResponse>('/imgapi/v1/image/edit', {
    method: 'POST',
    data,
    ...(options || {}),
  });
}

// 图片放大
export async function imageDownloadUpscale(
  data: {
    model_version: string;
    image_url: string;
    upscale_factor: string;
    source_system: string;
  },
  options?: { [key: string]: any },
) {
  return request<API.ApiResponse>('/imgapi/v1/image/upscale', {
    method: 'POST',
    data,
    ...(options || {}),
  });
}

// 图片分割
export async function imageSegment(
  data: {
    model_version: string;
    base_image: string;
    mode: string;
    prompt?: string;
    mask_image?: string;
  },
  options?: { [key: string]: any },
) {
  return request<API.ApiResponse>('/imgapi/v1/image/segment', {
    method: 'POST',
    data,
    ...(options || {}),
  });
}

// 图片上传

export async function imageUpload(
  data: {
    file: File;
    source_system: string;
  },
  options?: { [key: string]: any },
) {
  const formData = new FormData();
  formData.append('file', data.file);
  formData.append('source_system', data.source_system);
  return request<API.ApiResponse>('/imgapi/v1/image/file/upload', {
    method: 'POST',
    data: formData,
    ...(options || {}),
  });
}

// 视频上传
export async function videoUpload(
  data: {
    file: File;
    source_system: string;
  },
  options?: { [key: string]: any },
) {
  const formData = new FormData();
  formData.append('file', data.file);
  formData.append('source_system', data.source_system);
  return request<API.ApiResponse>('/veoapi/v1/video/file/upload', {
    method: 'POST',
    data: formData,
    ...(options || {}),
  });
}

/** Reel 画布批量上传：获取 GCS PUT 地址与 loading 画布结构。 */
export async function createCanvasAsyncUpload(data: API.CanvasAsyncUploadParams, options?: { [key: string]: any }) {
  return request<API.CanvasApiResponse<API.CanvasAsyncUploadData>>('/imgapi/v1/image/async_upload', {
    method: 'POST',
    data,
    ...(options || {}),
  });
}

/** Reel 画布批量上传：查询后端处理状态与最终画布结构。 */
export async function queryCanvasUploadResult(data: API.CanvasUploadResultParams, options?: { [key: string]: any }) {
  return request<API.CanvasApiResponse<API.CanvasUploadResultData>>('/imgapi/v1/image/upload_result', {
    method: 'POST',
    data,
    ...(options || {}),
  });
}
// 图片试穿
export async function imageTryOn(
  data: {
    model_version: string;
    person_image_url: string;
    product_image_urls: string[];
    output_options: string;
    base_steps: number;
  },
  options?: { [key: string]: any },
) {
  return request<API.ApiResponse>('/imgapi/v1/image/try_on', {
    method: 'POST',
    data,
    ...(options || {}),
  });
}

// 图片试穿
export async function reContext(
  data: {
    model_version: string;
    prompt: string;
    sample_count: number;
    product_images: string[];
    output_options: string;
    base_steps: number;
  },
  options?: { [key: string]: any },
) {
  return request<API.ApiResponse>('/imgapi/v1/image/re_context', {
    method: 'POST',
    data,
    ...(options || {}),
  });
}

export async function downloadSignedUrl(
  params: {
    url: string;
  },
  options?: { [key: string]: any },
) {
  console.log(params.url);
  return request<API.VideoRecordsList>(`/imgapi/v1/image/file/signed_url?url=${params.url}`, {
    method: 'GET',
    ...(options || {}),
  });
}

// /veoapi/v1/video/extend
export async function videoExtend(
  data: {
    model_version: string;
    prompt: string;
    input_video: string;
    person_generation: string;
    generate_audio: boolean;
    sample_count: number;
    duration_seconds: number;
  },
  options?: { [key: string]: any },
) {
  return request<API.ApiResponse>('/veoapi/v1/video/extend', {
    method: 'POST',
    data,
    ...(options || {}),
  });
}

// 查询视频任务当前进度与结果（chat-reel 画布轮询）
export async function queryVideoTaskStatus(
  data: {
    taskId: string;
  },
  options?: { [key: string]: any },
) {
  return request<API.ApiResponse>('/veoapi/v1/video/task/query', {
    method: 'POST',
    data,
    ...(options || {}),
  });
}
